import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { TransactionStatusEnum } from '../enums/transaction-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function transactionStatusToColor(
	status: TransactionStatusEnum | undefined | null,
): string {
	if (!status) {
		return RecordColorEnum.DEFAULT;
	}
	switch (status) {
		case TransactionStatusEnum.COMPLETED:
			return RecordColorEnum.GREEN;
		case TransactionStatusEnum.CANCELLED:
		case TransactionStatusEnum.FAILED:
		case TransactionStatusEnum.EXPIRED:
		case TransactionStatusEnum.REFUNDED:
			return RecordColorEnum.NEUTRAL;
		case TransactionStatusEnum.PROCESSING:
		case TransactionStatusEnum.RETRYING:
			return RecordColorEnum.AMBER;
		case TransactionStatusEnum.PENDING:
		default:
			return RecordColorEnum.DEFAULT;
	}
}
